import React, { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';

import { ErrorOverlayBody } from '../../error/error-overlay-body/component';
import { ErrorOverlay } from '../../error/error-overlay/component';

export const RegionalError: React.FC = () => (
    <ErrorOverlay>
        <ErrorOverlayBody>
            <FormattedMessage
                id="features.player.af48e0afb83f3b62d61537014579d624"
                defaultMessage={
                    "<div>You can't watch it in your region</div><div> or you need to </div><div>turn off VPN</div>"
                }
                description="Regional error message on player error screen"
                values={{
                    // eslint-disable-next-line react/no-unstable-nested-components
                    div: (chunks: ReactNode) => <div>{chunks}</div>,
                }}
            />
        </ErrorOverlayBody>
    </ErrorOverlay>
);
